export default __webpack_public_path__ + "static/media/menu-thumb.797d7a83.png";